/**
 * Book Worksheet Module
 * Main entry point for the Book Worksheet module
 */

// Import styles
import './styles/bookWorksheet.css';

// Import hooks
import useBookWorksheet from './hooks/useBookWorksheet';

// Import constants
import * as constants from './constants';

// Import utils
import * as utils from './utils';

// Import components
import * as components from './components';

// Import Redux slice
import bookWorksheetReducer from './slices/bookWorksheetDataSlice';

// Export hooks
export { useBookWorksheet };

// Export constants
export { constants };

// Export utils
export { utils };

// Export components
export { components };

// Export Redux slice
export { bookWorksheetReducer };

// Export individual components for convenience
export const {
  // UI Components
  StatusDisplay,
  StatusEditor,
  EntityCard,
  LitGroupForm,
  BookForm,
  CharacterForm,
  VariationFormUpgrade,
  VariationsList,
  VariationManagement,

  // Enhanced Components
  LitGroupsListEnh,
  BooksListEnh,
  CharactersListEnh,
  LitGroupManagementEnh,
  BookManagementEnh,
  CharacterManagementEnh,
  CharacterFormEnh,
  BookWorksheetPageEnh,
  BookWorksheetPageWrapperEnh,

  // Component Hooks
  useStatusManagement,
  useFormManagement,

  // Component Utils
  formatComponentName,
  generateComponentId
} = components;

// Export default
const bookWorksheetModule = {
  useBookWorksheet,
  constants,
  utils,
  components,
  bookWorksheetReducer
};

export default bookWorksheetModule;
